import moment from "moment";
import { createSelector } from "reselect";
import { ReportRecord } from "../interfaces/report-record";
import { TrafficReportRecord } from "./api-interfaces";
import { createDBServiceSlice } from "./db-service-reducers";

// trafficReport Reducer
export const {
    slice: TrafficReportSlice,
    dbThunks: _TrafficReportThunks,
    selectByQuery: _trafficReportSelectByQuery,
    selectOneObjectByQuery: _trafficReportSelectOneObjectByQuery,
    selectOneFieldByQuery: _trafficReportSelectOneFieldByQuery,
    selectors: _trafficReportSelectors,
    selectByQueryOnlyLength: _trafficReportSelectByQueryOnlyLength,
    selectByQueryOnlyMaxMin: _trafficReportSelectByQueryOnlyMaxMin,
} = createDBServiceSlice<TrafficReportRecord>({
    service: "traffic-report",
    initialState: { ids: [], entities: {}, itemsLoaded: false, itemsLoading: false },
    getReducerState: (state) => state.DBTrafficReportReducer,
});
export const DBTrafficReportReducer = TrafficReportSlice.reducer;
export const TrafficReportReducerActions = TrafficReportSlice.actions;
export type trafficReportReducerActions = keyof typeof TrafficReportReducerActions;
export const DBTrafficReportThunks = _TrafficReportThunks;
export const trafficReportSelectors = _trafficReportSelectors;
export const trafficReportSelectByQuery = _trafficReportSelectByQuery;
export const trafficReportSelectByQueryOnlyLength = _trafficReportSelectByQueryOnlyLength;
export const trafficReportSelectByQueryOnlyMaxMin = _trafficReportSelectByQueryOnlyMaxMin;
export const trafficReportSelectOneObjectByQuery = _trafficReportSelectOneObjectByQuery;
export const trafficReportSelectOneFieldByQuery = _trafficReportSelectOneFieldByQuery;

export interface DateRange {
    startDate: Date | null;
    endDate: Date | null;
}
export const selectReportsByDateRange = createSelector(
    [
        trafficReportSelectors.selectAll,
        (state: any, dateRange: DateRange) => dateRange
    ],
    (reports, dateRange: DateRange) => {
        const filteredReports = reports
            .map(report => {
                return {
                    ...report,
                    revenue: parseFloat(report.revenue.toFixed(2)),
                    date: moment(report.date),
                }
            })
            .filter(report => report.channelTag)
            .filter(report => report.date.isBetween(moment(dateRange?.startDate), moment(dateRange?.endDate), 'day', '[]'))

        filteredReports.sort((a, b) => b.date.diff(a.date))

        return filteredReports;
    }
)

export const selectReports = createSelector(
    trafficReportSelectors.selectAll,
    (reports) => {
        reports = reports
            .map(report => {
                return {
                    ...report,
                    revenue: parseFloat(report.revenue.toFixed(2)),
                    date: moment(report.date),
                }
            })
        reports.sort((a, b) => b.date.diff(a.date))

        return reports;
    }
)


